import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: "#E53935", // #E53935
          secondary: "#5da62e", // #FFCDD2
          third: colors.orange.lighten2,
          accent: colors.indigo.base, // #3F51B5
        },
      },
    },
  })
